import { capitalize } from 'lodash'
import { Parser, parserResponse, ParserVersion, tfx12Config } from './types'

export const getParserOptions = (optionsList: string[]) => {
  return optionsList.map(element => {
    return {
      label: capitalize(element),
      value: element,
    }
  })
}

export const getTfx12ConfigOptions = (optionsList: tfx12Config[]) => {
  return optionsList.map(option => {
    return {
      label: option.reference,
      value: option.reference,
    }
  })
}

export const hasExtractionErrors = (response: parserResponse) => {
  return response.extraction_errors && response.extraction_errors.length > 0
}

export const hasConversionErrors = (response: parserResponse) => {
  return response.conversion_errors && response.conversion_errors.join('').length > 0
}

/*
 ** Sorts an array of ParserVersions in ascending order by id
 */
export const sortParserVersionsById = (parserVersions: ParserVersion[]): ParserVersion[] => {
  return parserVersions.sort(({ id: a }, { id: b }) => a - b)
}

/*
 ** Takes a specific ParserVersion and an array of ParserVersions (sorted in ascending order by ID) and returns the associated version number
 */
export const findParserVersionNumber = (
  parserVersion: ParserVersion,
  parserVersions: ParserVersion[]
): number => {
  return parserVersions.findIndex(version => parserVersion.id === version.id) + 1
}

/*
 ** Returns array of ParserVersions such that each ParserVersion is assigned a version number and its associated parent parser
 */
export const formatParserVersions = (
  parsers: Parser[],
  parserVersions: ParserVersion[]
): ParserVersion[] => {
  return parserVersions.map(parserVersion => {
    const parentParser = parsers.find(
      parser => parserVersion.edi_mapper_configurable_parser_id === parser.id
    )
    const associatedParserVersions = parserVersions.filter(
      parserVersion => parserVersion.edi_mapper_configurable_parser_id === parentParser?.id
    )
    parserVersion.parent_parser = parentParser
    parserVersion.version_number = findParserVersionNumber(
      parserVersion,
      sortParserVersionsById(associatedParserVersions)
    )
    return parserVersion
  })
}

/*
 ** Returns array of Parsers such that each Parser is assigned all its associated ParserVersions
 */
export const formatParsers = (parsers: Parser[], parserVersions: ParserVersion[]): Parser[] => {
  return parsers.map(parser => {
    const mappedParser: Parser = {
      id: parser.id,
      name: parser.name,
      parserVersions: parserVersions.filter(
        parserVersion => parserVersion.edi_mapper_configurable_parser_id === parser.id
      ),
      createdAt: parser.createdAt,
      updatedAt: parser.updatedAt,
    }
    return mappedParser
  })
}

/*
 ** Conversion instructions are initialized as an empty json object so display this as an empty string
 */
export const formatConversionInstructions = (conversionInstructions: string) => {
  if (conversionInstructions === '{}') {
    return ''
  }
  return conversionInstructions
}
